.fibre-upgrade-message {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 $space-04;
    margin-top: $space-05;
  }

  &__title {
    h5 {
      font-family: $font-family-02;
      line-height: 28px !important;
      text-align: center;
      font-weight: 600 !important;
      font-size: $font-size-md-02 !important;

      @include agl-ds-screen-size('medium') {
        font-size: $font-size-md-04 !important;
      }
    }
  }

  &__subtitle {
    margin-top: $space-02;
    text-align: center;
  }
}
